import React from 'react';
import { useTranslation } from 'react-i18next';
import BoardMemberCard from '../../components/common/BoardMemberCard';
import MissionSection from '../../components/sections/MissionSection';
import FundingSection from '../../components/sections/FundingSection';
import SEO from '../../components/common/SEO';

const About = () => {
  const { t } = useTranslation();

  const boardMembers = [
    {
      name: 'Prof. Wael Adi',
      position: 'chairman',
      role: 'Information Technology (Technical University of Braunschweig)',
      link: 'https://www.tu-braunschweig.de/en/kns/faculty-and-staff/wael-adi'
    },
    {
      name: 'Dr. Yaser Daaboul',
      position: 'vice_chairman',
      role: 'Hochschule Hannover',
      link: 'https://annour-bs.de/about'
    },
    {
      name: 'Yaser Adi',
      position: 'registrar',
      role: 'Städtisches Klinikum Braunschweig gGmbH'
    },
    {
      name: 'Dipl.-Ing. Henning Maushake',
      position: 'treasurer',
      role: '',
      link: 'https://www.dasoertliche.de/Themen/Maushake-Henning-Ingenieurb%C3%BCro-Braunschweig-Watenb%C3%BCttel-Am-Bruchkamp'
    },
    {
      name: 'Prof. Dr. Reinhard Leithner',
      position: 'board_member',
      role: 'Mechanics, TU-Braunschweig',
      link: 'https://www.tu-braunschweig.de/ines/institut/team/prof-dr-techn-reinhard-leithner'
    },
    {
      name: 'Dr. Christos Pantazis',
      position: 'board_member',
      role: '(MdL Nds. SPD) State parliament of lower Saxony',
      link: 'https://christos-pantazis.spd.de/'
    },
    {
      name: 'Dipl.-Ing. Osman al Saqaqi',
      position: 'board_member',
      role: 'Leading management in Volkswagen-IT, Wolfsburg',
      link: 'https://www.linkedin.com/in/osman-al-saqaqy-4018258/?originalSubdomain=de'
    },
    {
      name: 'Carsten Müller',
      position: 'board_member',
      role: '(MdB CDU) Federal German Parliament',
      link: 'https://www.bundestag.de/webarchiv/abgeordnete/biografien18/M/mueller_carsten-258740'
    }
  ];

  return (
    <div className="py-12">
      <SEO 
        title={t('seo.aboutTitle')} 
        description={t('seo.aboutDescription')}
      />
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t('about.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('about.subtitle')}
          </p>
        </div>

        <MissionSection 
          title={t('about.missionTitle')}
          text={t('about.missionText')}
        />

        <div className="my-12">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
            {t('about.boardTitle')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {boardMembers.map((member, index) => (
              <BoardMemberCard
                key={index}
                name={member.name}
                position={t(`positions.${member.position}`)}
                role={member.role}
                  link={member.link}

              />
            ))}
          </div>
        </div>

        <FundingSection 
          title={t('about.fundingTitle')}
          text={t('about.fundingText')}
        />
      </div>
    </div>
  );
};

export default About;